import { render, staticRenderFns } from "./MissWordV.vue?vue&type=template&id=38ee3a8f"
import script from "./MissWordV.vue?vue&type=script&lang=js"
export * from "./MissWordV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports